import React, { useEffect, useState } from 'react'

//MUI IMPORTS
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Stack,
    Chip,
    Paper,
    Alert
} from "@mui/material";
import {
    Business as BusinessIcon,
    CalendarMonth as CalendarIcon,
    Description as FileIcon,
    Download as DownloadIcon,
    CheckCircle as CheckIcon,
    TryRounded,
} from "@mui/icons-material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import moment from 'moment';

//CUSTOM IMPORTS
import Navbar from '../../Navbar'
import { getData } from '../../../services/library';
import { UrlApi } from '../../../services/apirest';
import Notify from '../../Notify';
import SuccessScreen from '../SuccessScreen';

function LibroIvaDigital() {
    const [empresas, setEmpresas] = useState();
    const [periodos, setPeriodos] = useState();
    const anios = [moment().year()]
    const mesActual = moment().month() + 1
    const [LIDparams, setLIDParams] = useState({
        idEmpresa: null,
        mes: mesActual,
        anio: anios[0]
    });
    const [generando, setGenerando] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [respuestaExitosa, setRespuestaExitosa] = useState(false);

    useEffect(() => {
        // getData(`/empresas/facturadoras`, setEmpresas)
        getData(`/empresas/agrupadas/facturadoras`, setEmpresas)
        getData(`/meses`, setPeriodos)
    }, [])

    const handleLimpiar = () => {
        setLIDParams({
            idEmpresa: null,
            mes: null,
            anio: anios[0]
        })
    }

    const [notify, setNotify] = useState(null);

    const descargarArchivo = (nombre, contenido) => {

        const blob = new Blob([contenido], {
            type: "text/plain;charset=utf-8"
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");

        a.href = url;
        a.download = nombre;

        document.body.appendChild(a);

        a.click();

        a.remove();

        window.URL.revokeObjectURL(url);
    };

    const handleGenerar = async () => {
        const cuit = empresas.find(empresa=>empresa.idempresa == LIDparams.idEmpresa).cuit;

        try {
          setGenerando(true);

          const periodo = `${LIDparams.mes}-${LIDparams.anio}`;

          // const ruta = `${UrlApi}/archivos_salida/libro_iva_digital/${LIDparams.idEmpresa}/${periodo}`;
          const ruta = `${UrlApi}/archivos_salida/libro_iva_digital/${cuit}/${periodo}`;

          const response = await fetch(ruta);

          if (!response.ok) {
            throw new Error("Error al generar archivos");
          }

          const data = await response.json();
          // console.log(data)
          // return;

          if (
            data?.totalOmitidos === 0 &&
            data?.erroresValidacion?.length === 0
          ) {
            // Primer TXT
            descargarArchivo(
              data.libroVtasCbte.nombre,
              data.libroVtasCbte.contenido
            );

            // Segundo TXT
            setTimeout(() => {
              descargarArchivo(
                data.libroVtasAlicuotas.nombre,
                data.libroVtasAlicuotas.contenido
              );
            }, 300);
          }

          setNotify({
            open: true,
            message: "Archivos generados y descargados",
            severity: "success",
          });

          setTimeout(() => {
            setShowForm(false);
            setRespuestaExitosa(data);
          }, 1500); 

        } catch (error) {

            setNotify({
                open: true,
                message: error.message,
                severity: "error"
            });

        } finally {
            setGenerando(false);
        }
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#1565c0",
            },
            secondary: {
                main: "#43a047",
            },
            background: {
                default: "#f5f7fa",
            },
        },
        typography: {
            fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        },
        components: {
            MuiCard: {
                styleOverrides: {
                    root: {
                        borderRadius: 16,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 8,
                        textTransform: "none",
                        fontWeight: 600,
                    },
                },
            },
        },
    });

    return (
        <div>
            <Navbar />
            {
                showForm && (
                    <ThemeProvider theme={theme}>
                    <Box
                        sx={{
                            minHeight: "90vh",
                            bgcolor: "background.default",
                            p: 2
                        }}
                    >
                        <Box maxWidth={700} mx="auto">
                            <Box textAlign="center" mb={2}>
                                <Typography
                                    variant="h4"
                                    component="h1"
                                    fontWeight={700}
                                    color="primary.main"
                                    gutterBottom
                                >
                                    Generador de Libros IVA Digital
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    Genere los archivos TXT para presentación ante ARCA
                                </Typography>
                            </Box>
    
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    mb: 1,
                                    bgcolor: "#e3f2fd",
                                    borderRadius: 2,
                                    border: "1px solid #90caf9",
                                }}
                            >
                                <Typography variant="subtitle2" color="primary.dark" gutterBottom>
                                    Archivos que se generarán:
                                </Typography>
                                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                                    <Chip
                                        icon={<FileIcon />}
                                        label="Libro IVA Digital de Ventas (Comprobantes)"
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                    />
                                    <Chip
                                        icon={<FileIcon />}
                                        label="Archivo Libro IVA Digital Ventas Alícuotas"
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                    />
                                </Stack>
                            </Paper>
    
                            <Card>
                                <CardContent sx={{ p: 4 }}>
                                    <Stack spacing={3}>
                                        <FormControl fullWidth>
                                            <InputLabel id="empresa-label">
                                                Empresa
                                            </InputLabel>
                                            <Select
                                                labelId="empresa-label"
                                                value={LIDparams.idEmpresa}
                                                label="Empresa"
                                                onChange={(e) => setLIDParams({ ...LIDparams, "idEmpresa": e.target.value })}
                                                isOptionEqualToValue={(option, value) => option.idempresa === value.idempresa}
                                            >
                                                {empresas?.map((emp) => (
                                                    <MenuItem key={emp.idempresa} value={emp.idempresa}>
                                                        <Box>
                                                            <Typography variant="caption" color="text.secondary">
                                                                {emp.empresa}
                                                            </Typography>
                                                        </Box>
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <Box>
                                            <Typography
                                                variant="subtitle2"
                                                color="text.secondary"
                                                gutterBottom
                                                sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                            >
                                                <CalendarIcon fontSize="small" />
                                                Período (Mes Calendario)
                                            </Typography>
                                            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                                <FormControl sx={{ minWidth: 200 }}>
                                                    <InputLabel id="mes-label">Mes</InputLabel>
                                                    <Select
                                                        labelId="mes-label"
                                                        value={LIDparams.mes}
                                                        label="Mes"
                                                        onChange={(e) => setLIDParams({ ...LIDparams, mes: e.target.value })}
                                                    >
                                                        {periodos?.map((m) => (
                                                            <MenuItem key={m.id} value={m.id} disabled={m.id > mesActual}>
                                                                {m.mes}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
    
                                                <FormControl sx={{ minWidth: 150 }}>
                                                    <InputLabel id="anio-label">Año</InputLabel>
                                                    <Select
                                                        labelId="anio-label"
                                                        value={LIDparams.anio}
                                                        label="Año"
                                                        onChange={(e) => setLIDParams({ ...LIDparams, anio: e.target.value })}
                                                    >
                                                        {anios.map((anio) => (
                                                            <MenuItem key={anio} value={anio}>
                                                                {anio}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Stack>
                                        </Box>
                                        <Stack
                                            direction={{ xs: "column", sm: "row" }}
                                            spacing={2}
                                            justifyContent="flex-end"
                                        >
                                            <Button
                                                variant="outlined"
                                                onClick={handleLimpiar}
                                                disabled={generando}
                                            >
                                                Limpiar
                                            </Button>
                                            <Button
                                                variant="contained"
                                                size="large"
                                                startIcon={<DownloadIcon />}
                                                onClick={handleGenerar}
                                                disabled={generando || !LIDparams.idEmpresa || !LIDparams.mes || !LIDparams.anio}
                                                sx={{ minWidth: 200 }}
                                            >
                                                {generando ? "Generando..." : "Generar Archivos TXT"}
                                            </Button>
                                        </Stack>
                                    </Stack>
    
                                    {/* {archivosGenerados.length > 0 && (
                                        <Box mt={4}>
                                            <Alert
                                                severity="success"
                                                icon={<CheckIcon />}
                                                sx={{ mb: 2 }}
                                            >
                                                ¡Archivos generados exitosamente!
                                            </Alert>
                                            <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                                <Typography variant="subtitle2" gutterBottom>
                                                    Archivos descargados:
                                                </Typography>
                                                <List dense>
                                                    {archivosGenerados.map((archivo, index) => (
                                                        <ListItem key={index}>
                                                            <ListItemIcon>
                                                                <FileIcon color="primary" />
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                primary={archivo}
                                                                primaryTypographyProps={{
                                                                    variant: "body2",
                                                                    fontFamily: "monospace",
                                                                }}
                                                            />
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </Paper>
                                        </Box>
                                    )} */}
                                </CardContent>
                            </Card>
                        </Box>
                    </Box>
                    {
                        notify?.open && (
                            <Notify
                                open={notify?.open}
                                mensaje={notify?.message}
                                severity={notify?.severity}
                                handleClose={() => {
                                    setNotify({ open: false, message: "", severity: "success" })
                                }}
                            />
                        )
                    }
                </ThemeProvider>
                )
            }

            {respuestaExitosa && (
                <SuccessScreen
                    data={respuestaExitosa}
                 />
            )}


        </div>
    )
}

export default LibroIvaDigital